// Shared country / currency constants and helpers.
// Mirrors delivery_management's @next/infra/utils/get-country.ts — the single
// shared place for country/currency lookups (not tied to any feature module).

export enum CountryIds {
  TURKIYE = 1,
  AMERICA = 2,
  CHINA = 3,
  SPAIN = 4,
}

export enum CountryNames {
  AZERBAIJAN = 'Azərbaycan',
  TURKIYE = 'Türkiyə',
  AMERICA = 'Amerika',
  CHINA = 'Çin',
  SPAIN = 'İspaniya',
}

export enum CurrencySymbols {
  AZN = '₼',
  TRY = '₺',
  USD = '$',
  YEN = '¥',
  EURO = '€',
}

const CURRENCIES: Record<number, CurrencySymbols> = {
  [CountryIds.TURKIYE]: CurrencySymbols.TRY,
  [CountryIds.AMERICA]: CurrencySymbols.USD,
  [CountryIds.CHINA]: CurrencySymbols.USD,
  [CountryIds.SPAIN]: CurrencySymbols.EURO,
};

export const getCurrencySymbolByCountryId = (id: string | number | null | undefined): string => {
  if (!id) return '';
  return CURRENCIES[Number(id)] || CURRENCIES[CountryIds.AMERICA];
};

export const getCurrencySymbol = (currency: string | null | undefined): string => {
  if (!currency) return '';
  switch (currency.toUpperCase()) {
    case 'USD':
      return CurrencySymbols.USD;
    case 'TRY':
      return CurrencySymbols.TRY;
    case 'AZN':
      return CurrencySymbols.AZN;
    case 'AVRO':
      return CurrencySymbols.EURO;
    default:
      return currency;
  }
};

const COUNTRY_NAMES: Record<number, string> = {
  [CountryIds.TURKIYE]: 'Türkiyə',
  [CountryIds.AMERICA]: 'Amerika',
  [CountryIds.CHINA]: 'Çin',
  [CountryIds.SPAIN]: 'İspaniya',
};

export const getCountryName = (id: string | number | null | undefined): string => {
  if (!id) return '';
  return COUNTRY_NAMES[Number(id)] ?? '';
};

const COUNTRY_CONFIG: Record<number, { name: string; color: string }> = {
  [CountryIds.TURKIYE]: { name: COUNTRY_NAMES[CountryIds.TURKIYE], color: 'red' },
  [CountryIds.AMERICA]: { name: COUNTRY_NAMES[CountryIds.AMERICA], color: 'cyan' },
  [CountryIds.CHINA]: { name: COUNTRY_NAMES[CountryIds.CHINA], color: 'red' },
  [CountryIds.SPAIN]: { name: COUNTRY_NAMES[CountryIds.SPAIN], color: 'gold' },
};

export const getCountryConfig = (id: string | number | null | undefined): { name: string; color: string } | null => {
  if (!id) return null;
  return COUNTRY_CONFIG[Number(id)] || null;
};
